import type { PrinterService } from '../types';
import { SunmiPrinter } from './SunmiPrinter';
import { WebPrinter } from './WebPrinter';
import { devLog } from '@/lib/logger';

/** Detect VisionPOS standalone APK shell */
function isVisionPOSAndroid(): boolean {
  try {
    const w = window as any;
    return w.__VISIONPOS_ANDROID === true;
  } catch {
    return false;
  }
}

/** Detect Sunmi AIDL bridge injected by APK */
function hasSunmiBridge(): boolean {
  try {
    return (
      typeof (window as any).SunmiPrinter !== 'undefined' ||
      typeof (window as any).SunmiInnerPrinter !== 'undefined'
    );
  } catch {
    return false;
  }
}

/**
 * Factory: returns the best available PrinterService.
 *
 * Priority:
 * 1. Sunmi AIDL bridge (window.SunmiPrinter injected by APK WebView)
 * 2. Capacitor native platform (legacy path)
 * 3. WebPrinter (cloud Edge Function / window.print fallback)
 */
export const getPrinterService = (): PrinterService => {
  // 1) Sunmi AIDL bridge — works in APK WebView (VisionPOS shell or Capacitor)
  if (hasSunmiBridge()) {
    return new SunmiPrinter();
  }

  // 2) VisionPOS APK sans bridge Sunmi détecté (timing issue) — retry via SunmiPlugin lazy proxy
  if (isVisionPOSAndroid()) {
    devLog('[PrinterFactory] VisionPOS Android detected, using SunmiPrinter (lazy bridge)');
    return new SunmiPrinter();
  }

  // 3) Capacitor native platform (legacy path, if available)
  try {
    const { Capacitor } = require('@capacitor/core');
    if (Capacitor.isNativePlatform()) {
      return new SunmiPrinter();
    }
  } catch {}

  // 4) Web fallback (cloud printing via Edge Function, or window.print popup)
  return new WebPrinter();
};
